<template>
  <div v-if="loading === false">
    <div class="formSection__Columns">
      <div class="formSection__Column">
        <label class="formLabel" for="orgName">{{ $store.getters.getStringTranslation('orgFullTitle') }}</label>
        <input v-model="item.full_name" class="formInput" type="text" id="orgName" />
      </div>

      <div class="formSection__Column">
        <label class="formLabel" for="orgAbbr">{{ $store.getters.getStringTranslation('orgAbb') }}</label>
        <input v-model="item.abbreviation" class="formInput" type="text" id="orgAbbr" />
      </div>
    </div>
    <div class="formSection__Columns">
      <div class="formSection__Column">
        <label class="formLabel" for="editLocation">{{ $store.getters.getStringTranslation('address') }}</label>
        <input v-model="item.address" class="formInput" type="text" id="orgAbbr" />
      </div>

      <div class="formSection__Column">
        <label class="formLabel" for="orgEmail">{{ $store.getters.getStringTranslation('email') }}</label>
        <input v-model="item.email" class="formInput" type="email" id="orgEmail" />
      </div>
    </div>
    <div class="formSection__Columns">
      <div class="formSection__Column">
        <label class="formLabel" for="country">{{ $store.getters.getStringTranslation('country') }}</label>
        <search-tag
          v-if="item.country_id !== null || item.country_id !== undefined"
          :types="['country']"
          :multiple="false"
          :lang="lang"
          :tags="item.country"
          v-model="item.country_id"
          :placeholder="$store.getters.getStringTranslation('selectCountry')"
          :errorMessage="$store.getters.getStringTranslation('noCountries')"
          :showLabel="false"
          :limit="false"
          @handleParentTag="setParentTag"
        />
      </div>
      <div class="formSection__Column">
        <label class="formLabel" for="region">{{ $store.getters.getStringTranslation('region') }}</label>
        <search-tag
          v-if="item.region_id !== null || item.region_id !== undefined"
          :types="['region']"
          :multiple="false"
          :lang="lang"
          :tags="item.region"
          v-model="item.region_id"
          :placeholder="$store.getters.getStringTranslation('selectRegion')"
          :errorMessage="$store.getters.getStringTranslation('noRegions')"
          :showLabel="false"
          :limit="false"
          :countryParentTag="countryParentTag"
        />
      </div>
    </div>
    <div class="formSection__Row" v-if="isAdmin">
      <label class="formLabel" for="editAffiliateOf">{{ $store.getters.getStringTranslation('tagRepresent') }}</label>
      <search-tag
        v-if="item.organisation_id !== null || item.organisation_id !== undefined"
        :types="['organisation']"
        :multiple="false"
        :lang="lang"
        :tags="item.organisation"
        v-model="item.organisation_id"
        :placeholder="$store.getters.getStringTranslation('selectOrgTag')"
        :errorMessage="$store.getters.getStringTranslation('noAllies')"
        :showLabel="false"
        :limit="false"
      />
    </div>
    <div class="formSection__Row--Group">
      <label class="formLabel">{{ $store.getters.getStringTranslation('logoUpload') }} </label>
      <image-upload :required="true" v-model="item.contents.thumbnail_urls" v-if="item.contents"></image-upload>
    </div>
    <div class="formSection__Row--Group">
      <label class="formLabel">{{ $store.getters.getStringTranslation('coverImageUpload') }}</label>
      <image-upload :required="true" v-model="item.contents.cover_image_urls" v-if="item.contents"></image-upload>
      <p class="note">
        {{ $store.getters.getStringTranslation('coverPhotoNote') }}
      </p>
    </div>
    <div class="formSection__Row--Group">
      <ul class="cardPreview__Meta">
        <li v-for="translation in langs" :key="translation.id">
          <!-- Regular link for exising translation -->
          <template v-if="item.l10n.length > 0 && l10n[translation.toLowerCase()] !== undefined">
            <router-link class="cardPreview__MetaLink" :to="translationURL(translation)">
              {{ translation }}
              <icon
                name="check"
                v-if="
                  l10n.length > 0 &&
                  l10n[translation.toLowerCase()].foreword.length > 0 &&
                  l10n[translation.toLowerCase()].description.length > 0
                "
              ></icon>
            </router-link>

            <button v-if="item.l10n.length > 1" class="cardPreview__MetaPopup" @click="removeTranslation(translation)">
              <icon name="times"></icon>{{ $store.getters.getStringTranslation('remove') }}
            </button>
          </template>

          <!-- New translation -->
          <button class="cardPreview__MetaLink--Add" @click="addTranslation(translation)" v-else>
            {{ translation }}
            <icon name="plus" weight="solid"></icon>
          </button>
        </li>
      </ul>
      <p>
        <label class="formLabel" for="foreword">{{ $store.getters.getStringTranslation('shortDesc') }}</label>
        <text-editor v-model="l10n[lang].foreword" />
      </p>

      <p>
        <label class="formLabel" for="description">{{ $store.getters.getStringTranslation('description') }}</label>
        <text-editor v-model="l10n[lang].description" />
      </p>
    </div>
    <div class="formSection__Columns">
      <div class="formSection__Column">
        <label class="formLabel" for="facebook">Facebook URL</label>
        <input v-model="item.source.facebook" class="formInput" type="text" id="facebook" />
      </div>

      <div class="formSection__Column">
        <label class="formLabel" for="twitter">Twitter URL</label>
        <input v-model="item.source.twitter" class="formInput" type="text" id="twitter" />
      </div>
    </div>
    <div class="formSection__Row" v-if="isAdmin">
      <label class="formLabel" for="editAffiliateOf">{{ $store.getters.getStringTranslation('affiliateId') }}</label>
      <input v-model="item.affiliate_of_id" type="number" class="formInput" id="editAffiliateOf" />
      <span class="note">
        {{ $store.getters.getStringTranslation('affiliateIdDesc') }}
      </span>
    </div>

    <div
      v-if="
        (item.contents.additionals && item.contents?.additionals?.is_org) ||
        item.contents?.additionals?.non_profit ||
        item.contents?.additionals?.non_political ||
        item.contents?.additionals?.public_interest
      "
      class="formSection__Row formSection__Row--Additional"
    >
      <label class="formLabel">Additional info:</label>
      <ul class="orgDetailsList">
        <li v-if="item.contents.additionals.is_org" class="orgDetailsList__Item">
          <span class="orgDetailsList__Icon"><icon name="check" /></span>
          <span class="orgDetailsList__Text">We are organization</span>
        </li>
        <li v-if="item.contents.additionals.non_profit" class="orgDetailsList__Item">
          <span class="orgDetailsList__Icon"><icon name="check" /></span>
          <span class="orgDetailsList__Text">We are non profit</span>
        </li>
        <li v-if="item.contents.additionals.non_political" class="orgDetailsList__Item">
          <span class="orgDetailsList__Icon"><icon name="check" /></span>
          <span class="orgDetailsList__Text">We are not a political party</span>
        </li>
        <li v-if="item.contents.additionals.public_interest" class="orgDetailsList__Item">
          <span class="orgDetailsList__Icon"><icon name="check" /></span>
          <span class="orgDetailsList__Text">We are fighting in public interest</span>
        </li>
      </ul>
    </div>

    <div class="formSection__Row formSection__Row--UploadedDocs">
      <template v-if="organizationDocuments.length > 0">
        <label class="formLabel">Organization documents</label>
        <ul v-if="organizationDocuments.length > 0" class="orgDocs">
          <li v-for="file in organizationDocuments" :key="file.id" class="orgDocs__Item">
            <a :href="file.url" target="_blank" class="orgDocs__Link">
              <div class="orgDocs__IconBox">
                <icon name="file-alt"></icon>
              </div>
              <div class="orgDocs__ItemContent">
                <div class="orgDocs__Title">{{ file.name }}</div>
                <div class="orgDocs__Date">{{ file.type }}</div>
              </div>
            </a>
          </li>
        </ul>
        <p v-if="false" class="noOrgDocuments">No uploaded documents</p>
      </template>

      <label class="formLabel">
        <template v-if="organizationDocuments.length > 0">Reupload document: </template>
        <template v-else>Upload organization document: </template>
      </label>

      <div class="simpleFileUpload">
        <div class="simpleFileUpload__Choose">
          <label for="simple-file-upload" class="simpleFileUpload__Label">Choose document</label>
          <input
            type="file"
            id="simple-file-upload"
            accept="image/*, application/pdf, application/msword, application/vnd.ms-excel"
            @change="handleFileSelect"
            class="simpleFileUpload__Input"
          />
        </div>
        <div v-for="file in selectedFiles" :key="file.id" class="simpleFileUpload__FileName">
          <span>
            {{ file.name }}
          </span>
        </div>
      </div>
      <button v-if="selectedFiles.length > 0" class="button button--UploadedDocs" @click.prevent="uploadFiles(org.id)">
        Upload
      </button>
    </div>
  </div>
</template>

<script>
import HTTP from '@/http-common.js'

import { ISOlanguages } from '@/router/globals.js'

import GetProperty from '@/components/mixins/GetProperty.js'
import TextEditor from '@/components/editor/TextEditor.vue'
import ManageTranslations from '@/components/mixins/ManageTranslations.js'
import ReduceItemData from '@/components/mixins/ReduceItemData.js'

import SearchTag from '@/components/editor/blocks/SearchTag.vue'
import ImageUpload from '@/components/editor/ImageUpload.vue'

export default {
  props: ['org', 'loading'],
  components: {
    TextEditor,
    SearchTag,
    ImageUpload,
  },
  data() {
    return {
      countryParentTag: null,
      organizationDocuments: [],
      selectedFiles: [],
    }
  },
  mixins: [GetProperty, ManageTranslations, ReduceItemData],

  mounted() {
    this.getOrgDocuments()
  },

  computed: {
    // Return lang data from URL query, if query exists
    lang() {
      if (this.$route.query.lang !== undefined) {
        return this.$route.query.lang
        //  If not, retrieve language from search parameters
      } else {
        return 'en'
      }
    },
    langs() {
      return ISOlanguages
    },
    item: {
      get() {
        this.transformTranslationData(this.org.l10n)
        return this.org
      },
      set() {
        this.$emit('input', this.item)
        this.errors = []
      },
    },
    user() {
      return this.$store.state.accounts.user
    },
    isAdmin() {
      if (this.user.is_admin) return true
      return false
    },
  },
  methods: {
    setParentTag(tag) {
      this.countryParentTag = tag
    },
    async getOrgDocuments() {
      console.log('yolo')
      HTTP.get(`org/${this.item.id}/documents`).then((response) => {
        this.organizationDocuments = response.data
      })
    },
    handleFileSelect(event) {
      this.selectedFiles = Array.from(event.target.files)
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1)
    },
    uploadFiles(org_id) {
      const formData = new FormData()
      formData.append('file', this.selectedFiles[0])
      formData.append('org_id', org_id)
      formData.append('hidden', true)

      HTTP.post(`upload`, formData)
        .then((response) => {
          console.log(response)
          this.organizationDocuments.push(response.data)
          this.selectedFiles = []
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
}
</script>
